import '@/styles/application.sass'
import * as ActiveStorage from '@rails/activestorage'
import Rails from '@rails/ujs'

require.context('../images', true, /\.(png|jpg|jpeg|svg|ico)$/)

Rails.start()
ActiveStorage.start()
;(global as any).Rails = Rails
